require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/pages/user-account.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/pages/user-account.legacy.js
// module id = 670
// module chunks = 31